import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../shared/auth.service';
import { BreadcrumbService } from '../../shared/breadcrumb/breadcrumb.service';
import { Kernantwort } from '../../shared/response/kernantwort.model';
import { SessionService } from '../../shared/session.service';

import { HttpClient } from "@angular/common/http";
import { L10N_CONFIG, L10N_LOCALE, L10nConfig, L10nLocale, L10nTranslatePipe, L10nTranslationService } from 'angular-l10n';
import { APIConfigService } from "../../api.config.service";
import { AngularMaterial2Module } from "../../app.module.material";
import { ErrorHelper } from "../../shared/error.helper";
import { LoggerService } from '../../shared/logger.service';

const PATH_FILE = 'app/protected/import/import.component.ts';
const OBJ_LNG_NAME = 'import';
const BACKEND_PATH_PREFIX = 'import/';

@Component({
  selector: 'oase-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.css'],
  standalone: true, imports: [AngularMaterial2Module, L10nTranslatePipe, FormsModule]

})
export class ImportComponent {

  private isAjaxCallRunning: boolean = false;
  private fehlerMain: Kernantwort;
  public OBJ_LNG_NAME = OBJ_LNG_NAME;
  public disableImport: boolean = true;
  private REST_API: string = null;
  private importInterval?: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public authService: AuthService,
    public apiConfigService: APIConfigService,
    public http: HttpClient,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    @Inject(L10N_CONFIG) private config: L10nConfig,
    public translation: L10nTranslationService, public sessService: SessionService,
    public title: Title,
    private _logger: LoggerService) {
    // Set document title.
    this.title.setTitle(this.getTitle());
    this.laeuftImport();
    this.REST_API = this.apiConfigService.REST_API_BASE() + BACKEND_PATH_PREFIX;
  }

  getTitle() {
    return this.translation.translate('import.titel');
  }

  public laeuftImport(): boolean {
    this._logger.debug(PATH_FILE + ' - laeuftImport importInterval: ' + this.importInterval);
    // Clear any existing interval to prevent multiple intervals from running.
    if (this.importInterval) {
      clearInterval(this.importInterval);
      this.importInterval = null;
    }

    // Initial check and possibly setting up an interval
    if (this.disableImport && !this.isAjaxCallRunning) {
      this.performRequest();
    } else {
      this._logger.debug('Import is currently disabled; setting up retry in 2 seconds.');
      // Set up an interval to retry every 2 seconds when this.disableImport is true.
      this.importInterval = window.setInterval(() => {
        this._logger.debug('Attempting to perform request again.');
        if (this.disableImport && !this.isAjaxCallRunning) {
          this.performRequest();
        }
      }, 2000);
    }
    return this.disableImport;
  }

  // Extracted helper function to perform the request
  private performRequest(): void {
    this.isAjaxCallRunning = true;
    this.http.get<boolean>(this.apiConfigService.REST_API_BASE() + BACKEND_PATH_PREFIX + 'laeuftImport/').subscribe({
      next: (data) => {
        this._logger.log(PATH_FILE + ' - performRequest response: ', data);
        this.disableImport = data;
        // If import is disabled, stop any interval that may be running.
        if (!this.disableImport && this.importInterval) {
          clearInterval(this.importInterval);
          this.importInterval = null;
        }
      },
      error: (err) => {
        ErrorHelper.handleError(err, "Fehler beim Anstoßen des Imports", this._logger, this.translation)
        this.isAjaxCallRunning=false;
      },
      complete: () => {
        this.isAjaxCallRunning=false;
      }
    });
  }


  public importiereDateien() {
    this.disableImport = true;
    this.http.get<any>(this.apiConfigService.REST_API_BASE() + BACKEND_PATH_PREFIX + 'startImport/').subscribe({
      next: (data) => {
        this._logger.log(PATH_FILE + ' - importiereDateien response: ', data);
        this.openSnackBar(this.translation.translate(OBJ_LNG_NAME + '.gestartet'));
      },
      error: (err) => ErrorHelper.handleError(err, "Fehler beim Anstoßen des Imports", this._logger, this.translation)
    });
  }

  setzeFehler(fehler: Kernantwort) {
    this.fehlerMain = fehler;
  }

  openSnackBar(message: string, action: string = null) {
    this.snackBar.open(message, action, { duration: 5 * 1000 });
  }
}

